import Plaque from "./Plaque";
import { useState } from "react";

import { plaque_values, donor_plaques, base_size, half_size } from "./data.js";

function PlaqueWrapper(props) {
  const { size, x, y, base_size, text, sold } = { ...props };

  const [show, setShow] = useState(false);
  const [hover, setHover] = useState(false);
  return (
    <>
      <Plaque
        onClick={(e) => {
          console.log(e);
          e.preventDefault();
          e.stopPropagation();
          setShow(!show);
        }}
        size={size}
        scale={show ? 3 : 1}
        x={x}
        y={y}
        base_size={base_size}
        text={
          show & !sold ? (
            <span>
              Your name
              <br />
              here!
              <div
                style={{
                  backgroundColor: hover ? "white" : "lightgrey",
                  color: "black",
                  border: hover ? "1px solid blue" : "1px solid grey",
                  height: "5px",
                  maxHeight: "5px",
                  fontSize: "5px",
                  padding: "2px",
                  paddingTop: "0px",
                  overflow: "clip",
                  marginTop: "2px",
                }}
                onPointerEnter={() => setHover(true)}
                onPointerLeave={() => setHover(false)}
                onClick={() => {
                  window.parent.location =
                    "https://giving.ucla.edu/Campaign/Donate.aspx?SiteNum=136&amount=" +
                    plaque_values[size];
                }}
              >
                Donate Now&rarr;
              </div>
            </span>
          ) : sold ? (
            text
          ) : (
            ""
          )
        }
      />
    </>
  );
}

export default function DonorBoard(props) {
  const { scale } = { ...props };

  return (
    <div
      style={{
        transform: `scale(${scale})`,
        transformOrigin: "0 0",
        minWidth: `${13 * scale * half_size}px`,
        width: `${13 * scale * half_size}px`,
        minHeight: `${6 * scale * half_size}px`,
        height: `${6 * scale * half_size}px`,
      }}
    >
      {donor_plaques.map((p, n) => (
        <PlaqueWrapper
          key={n}
          size={p.size}
          x={p.x}
          y={p.y}
          base_size={base_size}
          text={p.text}
          sold={p.sold}
        />
      ))}
    </div>
  );
}
